import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

// Estilos para a Sidebar
export const SidebarContainer = styled.div`
  display: none;
  font-family: Poppins;

  @media screen and (max-width: 768px) {
    position: fixed;
    top: 0;
    left: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
    width: 250px;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Alinhar itens à esquerda */
    justify-content: flex-start; /* Alinhar itens ao topo */
    transition: 0.3s ease-in-out;
    z-index: 999;
    padding-top: 1rem; /* Adicionar espaçamento no topo */
    padding-left: 1rem; /* Adicionar espaçamento à esquerda */
  }
`;

export const SidebarMenu = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Alinhar itens à esquerda */
  text-align: left; /* Alinhar texto à esquerda */
  width: 100%;
`;

export const SidebarLink = styled(Link)`
  text-decoration: none;
  color: #000;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
`;

export const SidebarIcon = styled.span`
  margin-right: 0.5rem;
  padding-top: 0.5rem; /* Adicionar espaçamento no topo */
`;

export const SidebarLogo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0 1rem;
`;
